import React from 'react'
import "./footer.css"

export default function Footer() {
    return (
        <>
            <footer className="footer">
                <div className="footer-container">
                    <div className="left">
                        <div className="location">
                            <p>
                                <i className="fa-solid fa-location-dot"></i>
                                Dadanshah Hyderabad, <br />
                                Pakistan.
                            </p>
                        </div>
                        <div className="phone">
                            <h4>
                                <i className="fa-solid fa-phone"></i>
                                +923113318633
                            </h4>
                        </div>
                        <div className="email">
                            <h4>
                                <i className="fa-solid fa-envelope"></i>
                                hk7356231@gmail.com
                            </h4>
                        </div>
                    </div>

                    <div className="right">
                        <h4>About me</h4>
                        <p>
                            Heyy.. I'm Muhammad Hammad Khan. responsible for br planning and
                            developing software solutions and web applications.
                        </p>
                        <div className="icons">
                            <a href="https://m.facebook.com/profile.php?id=100011556826825&eav=AfY2o7yZGFGqZe6DRY6Ok5U02O67KcZCkKkkK7zX9IUcclMq7OXri8bdPIPyhyDMWuk&paipv=0"> <i className="fa-brands fa-facebook"></i> </a>
                            <a href="https://instagram.com/hammad_khan044"><i className="fa-brands fa-instagram"></i></a>
                            <a href="https://twitter.com/hk7356231"><i className="fa-brands fa-twitter"></i></a>
                        </div>
                    </div>
                </div>

                <div className="main">
                    <p>© Hammadkhan.com 2022. All Rights Reserved</p>
                </div>

            </footer>
        </>
    )
}
